export default __webpack_public_path__ + "static/media/ConteudoPagina.66574b3a.svg";